import { useContext } from "react";
import { useSnackbar } from "notistack";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Alert, Snackbar, Slide } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { HelmetProvider, Helmet } from "react-helmet-async";
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import createTheme from "./theme";
import Router from "./router/Router";
import "./pages/welcome page components/style.css";
import "./pages/css components/style.css";
import { closeAlert } from "./redux/slices/alertSlice";
import { ThemeContext } from "./components/ThemeProvider";
import AuthVerification from "./components/AuthVerification";

function App() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alertDetails);
  const { theme } = useContext(ThemeContext);
  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | Sprintexx"
        defaultTitle="ADN-Sprintexx Dashboard"
      />
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={createTheme(theme)}>
              <ThemeProvider theme={createTheme(theme)}>
                {alert.multiple ? (
                  alert.multiple.map((msg) => (
                    <div style={{ display: "none" }}>
                      {enqueueSnackbar(msg, {
                        variant: alert.type,
                        autoHideDuration: 4000,
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                      })}
                    </div>
                  ))
                ) : (
                  <Snackbar
                    open={alert.state}
                    autoHideDuration={4000}
                    onClose={handleAlertClose}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    slots={{ transition: SlideTransition }}
                    sx={{
                      top: 8,
                      right: 10,
                      pointerEvents: "none",
                      zIndex: 1400,
                    }}
                  >
                    <Alert
                      variant="filled"
                      severity={alert.type}
                      onClose={handleAlertClose}
                      sx={{ minWidth: 350, pointerEvents: "auto" }}
                    >
                      {alert.message}
                    </Alert>
                  </Snackbar>
                )}

                <Router />
                <AuthVerification />
              </ThemeProvider>
            </MuiThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  );

  function SlideTransition(props) {
    return <Slide {...props} direction="right" />;
  }

  function handleAlertClose(_, reason) {
    if (reason === "clickaway") {
      return;
    }

    dispatch(closeAlert());
  }
}

export default App;
